import { cpanelAnnouncementsRoutes } from '~/router/routes/car/cpanel/announcements'
import { cpanelOffersRoutes } from '~/router/routes/car/cpanel/offers'

export default [...cpanelAnnouncementsRoutes, ...cpanelOffersRoutes]
